// extracted by mini-css-extract-plugin
export default {"taskView":"TaskView_taskView__ETrHG","taskCards":"TaskView_taskCards__zOICT","createTask":"TaskView_createTask__egbOz","addAndSearch":"TaskView_addAndSearch__-NB-X"};